import React from 'react';
import clsx from 'clsx';
import { ReactComponent as CheckIcon } from 'images/green-check.svg';
import { ReactComponent as WaveformIcon } from 'images/waveform-icon.svg';

import styles from './MetricCard.module.scss';

export interface MetricItem {
  label: string;
  value: string;
}

export enum VariabilityStatus {
  Steady = 'Steady',
  Varies = 'Varies',
  VariesALot = 'VariesALot',
}

interface MetricCardProps {
  items: MetricItem[];
  className?: string;
}

interface VariabilityStatusPillProps {
  status: VariabilityStatus;
}

const variabilityStatusLabels = {
  [VariabilityStatus.Steady]: 'Steady',
  [VariabilityStatus.Varies]: 'Varies',
  [VariabilityStatus.VariesALot]: 'Varies a lot',
};
const variabilityStatusIcons = {
  [VariabilityStatus.Steady]: <CheckIcon className={styles.checkIcon} />,
  [VariabilityStatus.Varies]: <WaveformIcon className={styles.variesIcon} />,
  [VariabilityStatus.VariesALot]: <WaveformIcon className={styles.variesALotIcon} />,
};

export const VariabilityStatusPill: React.FC<VariabilityStatusPillProps> = ({ status }) => (
  <div className={clsx(styles.pill, styles[`pill--${status}`])}>
    {variabilityStatusIcons[status]}
    <p className={styles.variabilityStatusLabel}>{variabilityStatusLabels[status]}</p>
  </div>
);

const MetricCard: React.FC<MetricCardProps> = ({ items, className }) => (
  <div className={clsx(styles.card, className)}>
    <div className={styles.items}>
      {items.map((item, index) => (
        <div key={index} className={styles.item} data-last={index === items.length - 1}>
          <div className={styles.itemContent}>
            <div className={styles.itemText}>
              <div className={styles.itemRow}>
                <p className={styles.itemLabel}>{item.label}</p>
                <p className={styles.itemValue}>{item.value}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default MetricCard;
